import script from "./url-qr.vue?vue&type=script&setup=true&lang=js"
export * from "./url-qr.vue?vue&type=script&setup=true&lang=js"

import "./url-qr.vue?vue&type=style&index=0&id=2b01e2ba&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b01e2ba"]])

export default __exports__